// extracted by mini-css-extract-plugin
module.exports = {"progressIcon":"index_progressIcon_2PFK_"};